import { Directive, Input, ElementRef, OnInit, OnChanges } from '@angular/core';

@Directive({
  selector: '[twoDigitNumber]',
  standalone: false,
})
export class TwoDigitNumberDirective implements OnInit, OnChanges {
  @Input() number: number;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.makeTwoDigitNumber();
  }

  ngOnChanges() {
    this.makeTwoDigitNumber();
  }

  makeTwoDigitNumber() {
    const number =
      this.number < 10 ? '0' + this.number : this.number.toString();
    this.el.nativeElement.innerText = number + '.';
  }
}
